import { Component, ViewChild, ElementRef, OnDestroy, OnInit } from '@angular/core';

// Enums
import { Vistas } from 'src/app/shared/enums/vistas';

// Models
import { Pagina, Seccion } from 'src/app/shared/models/pages';

// Services
import { AssetsService } from 'src/app/shared/services/assets.service';
import { PageService } from 'src/app/shared/services/page.service';

// Utils
import { setPageTitle } from 'src/app/shared/utilities/utils';
import { AppService } from 'src/app/app.service';
import { MetatagsService } from 'src/app/shared/services/metatags.service';
import { CanonicalRoutesService } from 'src/app/shared/services/canonical-routes.service';

@Component({
  selector: 'app-afiliates',
  templateUrl: './afiliates.component.html',
  styleUrls: ['./afiliates.component.scss']
})
export class AfiliatesComponent implements OnInit, OnDestroy {
  // Page general content
  public pageData: Pagina;
  public benefits: Seccion;
  public upAnalytics: Seccion;

  public imgAnalytics: string;

  isOpen = false;

  @ViewChild('modalInfo') modal: ElementRef;

  private appEnvironment: string;

  constructor(
    private pageService: PageService,
    private assetsQuery: AssetsService,
    private app: AppService,
    private metaTags: MetatagsService,
    private canonical: CanonicalRoutesService
  ) {
    this.appEnvironment = this.app.configuration['GraphCMS']['environment'];

    this.pageService
      .getPage(
        Vistas.Afiliates,
        'Afiliados',
      )
      .subscribe((data: Pagina) => {
        this.pageData = data;
        this.benefits = this.filterSection('beneficio-afiliado');
        this.upAnalytics = this.filterSection('afiliados-up-analytics');

        const titleElement = document.querySelector('title');
        setPageTitle(titleElement, this.pageData.vista);
        this.metaTags.setMetaTags(data.metaDescripciones);
      });

    this.assetsQuery
      .getAsset('img-analytics.svg')
      .subscribe(data => (this.imgAnalytics = data[0].url));
  }

  ngOnInit(): void {
    this.canonical.setCanonicalRoute();
  }

  ngOnDestroy(): void {
    this.metaTags.removeMetaTags(this.pageData.metaDescripciones);
  }

  private filterSection(section: string): Seccion {
    return this.pageData.secciones.find(item => item.idSeccion === section);
  }

  openModal() {
    this.modal.nativeElement.classList.add('open');
  }

  closeModal() {
    this.modal.nativeElement.classList.remove('open');
  }

  clickModal(event) {
    if (event.target === this.modal.nativeElement) {
      this.closeModal();
    }
  }

  onKeyDown(event) {
    if (event.keyCode === 27 || event.key === 'Escape') {
      this.closeModal();
    }
  }
}
